export const URLS = {
  MAIN: '/',
  JOIN: '/join',
  FANS: '/fans',
  FOR_CLUBS: '/for-clubs',
  FOR_BRANDS_CONTACT_MAILTO: 'mailto:partnership@bcsarena.io',
  TASKS: '/tasks',
  TIMER: '/timer',
  HOW_IT_WORKS: '/',
  PROFILE: '/profile',
  PROFILE_ARENA_POINTS: '/profile?tab=arena-points',
  CLUB_PROFILE: '/club-profile',
  LEADERBOARD: '/leaderboard?sport=all',
  LEADERBOARD_CLUBS: '/leaderboard?audience=clubs&sport=all',
  CLUBS: '/clubs',
  CLUB_REGISTER: '/clubs/register',
  CLUB_MODERATION: '/clubs/moderation',
  CLUB_DETAIL: (id: string) => `/clubs/${id}`,
  CHALLENGES: '/tasks',
  TASK_WATCH: (taskId: string, opts?: { view?: 'closed' }) => {
    const path = `/tasks/watch/${taskId}`
    if (opts?.view === 'closed') {
      return `${path}?view=closed`
    }
    return path
  },
  TASK_SHARE: (taskId: string, opts?: { view?: 'closed' }) => {
    const path = `/tasks/share/${taskId}`
    if (opts?.view === 'closed') {
      return `${path}?view=closed`
    }
    return path
  },
  TASK_ACTION: (taskId: string, opts?: { view?: 'closed' }) => {
    const path = `/tasks/action/${taskId}`
    if (opts?.view === 'closed') {
      return `${path}?view=closed`
    }
    return path
  },
  TASK_CREATE: (taskId: string, opts?: { view?: 'closed' }) => {
    const path = `/tasks/create/${taskId}`
    if (opts?.view === 'closed') {
      return `${path}?view=closed`
    }
    return path
  },
  NEWS: '/news',
  NEWS_DETAIL: '/news/:id',
  FAQ: '/#faq',
  PLATFORM_BLOCK: '/#platform-block',
  PROFILE_EDIT: '/profile/edit',
  // US-ATH-02.4: where a blocked account lands after signing in with Google.
  ACCOUNT_BLOCKED: '/account-blocked'
}

/** Wrap a document URL in the Google Docs viewer so it opens in-browser
 *  instead of being downloaded (browsers cannot render .docx natively). */
const googleDocsViewer = (url: string): string =>
  `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`

/** Version of the Terms of Use / Privacy Policy linked above. Sent with every
 *  sign-up as `terms_version` (BAT-1092: stored as consent, required for
 *  athletes). Bump together with the document URLs. */
export const TERMS_VERSION = 'v2'

// The address «Contact support» writes to where no in-app ticket is possible
// (a blocked account has no session to open one with).
export const SUPPORT_EMAIL = 'support@bcsarena.io'

export const POLICIES_DOCUMENTS = {
  PRIVACY_POLICY: googleDocsViewer(
    'https://aws-arena-main-prod-s3-arena-bucket.s3.us-east-1.amazonaws.com/club_documents/BCS_Arena_Privacy_Policy_v2.docx'
  ),
  // v2 is a .docx now (was .pdf), so it must go through the Docs viewer to open
  // in the browser like the other policies.
  COOKIE_POLICY: googleDocsViewer(
    'https://aws-arena-main-prod-s3-arena-bucket.s3.us-east-1.amazonaws.com/club_documents/BCS_Arena_Cookie_Policy_v2.docx'
  ),
  AML_POLICY:
    'https://storage.googleapis.com/bcsports-bucket/ecosystem-static/docs/AML_Policy.pdf',
  TERMS_OF_USE: googleDocsViewer(
    'https://aws-arena-main-prod-s3-arena-bucket.s3.us-east-1.amazonaws.com/club_documents/BCS_Arena_Terms_of_Use_v2.docx'
  )
}

export const SOCIAL_NETWORKS = {
  MEDIUM: '',
  ZEALY: '',
  TWITTER: 'https://x.com/bcs_arena',
  YOUTUBE: 'https://www.youtube.com/@BCS_Arena',
  INSTAGRAM: 'https://www.instagram.com/bcs.arena',
  TIKTOK: 'https://www.tiktok.com/@arena.bcs',
  FACEBOOK: 'https://www.facebook.com/bcs.arena',
  DISCORD: 'https://discord.gg/FCyeDArWJu',
  TELEGRAM: 'https://t.me/bcs_arena'
}
